import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';

import { StepWizardChildProps } from '../StepWizard';
import Step from './components/Step';
import Question from './components/Question';
import ToggleButton from './components/ToggleButton';
import ToggleButtonGroup from './components/ToggleButtonGroup';

interface Props extends Partial<StepWizardChildProps> {
  onUpdate?: (data: any, step: number) => void;
  onValidate?: (valid: boolean) => void;
}

const StepDogOrCat = ({ onUpdate, onValidate }: Props) => {
  const [species, setSpecies] = useState<'Dog' | 'Cat'>();

  useEffect(() => {
    if (typeof onValidate === 'function') {
      if (typeof species !== 'undefined') {
        onValidate(true);
      } else {
        onValidate(false);
      }
    }
  }, [species]);

  const handleChange = (event, value) => {
    if (!!value) {
      setSpecies(value);
      if (typeof onUpdate === 'function') {
        onUpdate({ species: value }, 1);
      }
    }
  };

  return (
    <Box>
      <Step num={1} />
      <Question label="Do you have a dog or a cat?" />
      <Box display="flex" justifyContent="center">
        <ToggleButtonGroup
          value={species}
          exclusive
          onChange={handleChange}
          aria-label="dog or cat"
          size="large"
        >
          <ToggleButton value="Dog" aria-label="Dog">
            Dog
          </ToggleButton>
          <ToggleButton value="Cat" aria-label="Cat">
            Cat
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};
export default StepDogOrCat;
